const currencies = require('./currencies.json');

export const data = {
  'verify': {
    number: { key: 'number', name: 'Number', required: true },
  },

  'license': {
    left: {
      name: { key: 'name', name: 'Name', required: true, validations: 'maxLength:50' },
      address: { key: 'address', name: 'Address', type: 'textarea', required: true, validations: 'maxLength:300' },
    },
    right: {
      email: { key: 'email', name: 'Email', required: true, validations: 'maxLength:100,isEmail', disable: ['update'] },
      telephone: { key: 'telephone', name: 'Telephone', type: 'tel', mask: "+9{1,20}", required: true, validations: 'maxLength:50' }
    }
  },

  'public': {
    left: {
      p_owner: { key: 'p_owner', name: 'Owner', required: true, validations: 'maxLength:100' },
      p_descr: { key: 'p_descr', type: 'textarea', name: 'Description', required: true, validations: 'maxLength:200' },
      p_loc: { key: 'p_loc', name: 'Location', required: true, validations: 'maxLength:100' },
      p_contact: { key: 'p_contact', name: 'Contact', required: true, validations: 'maxLength:100,isEmail' },
    },
    right: {
      sale: { key: 'sale', name: 'For Sale', type:"checkbox", related: ['s_price', 's_cur', 's_url'] },
      s_price: { key: 's_price', name: 'Price', relateTo: "sale", mask: {
        alias: 'currency', repeat: 10
      }, validations: '' },
      s_cur: { 
        key: 's_cur',
        name: 'Currency',
        type: 'simpleselect',
        options: Object.keys(currencies).map(currencyKey => {
          const currency = currencies[currencyKey];
          return {label: `${currencyKey} - ${currency}`, value: currencyKey }
        }),
        relateTo: "sale",
        optionsExtra: [
          {
            label: 'empty', value: '',
          }
        ],
      },
      s_url: { key: 's_url', relateTo: "sale", mask: {
        alias: 'url',
      }, name: 'URL', validations: 'isUrl' },
    }
  },
  disclaimers: {
    first: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.'
  },

  keysSubDetail: {
    'available': 'available',
    'cert_public_contact': 'contact',
    'cert_public_currency': 'currency',
    'cert_public_description': 'description',
    'cert_public_location': 'location',
    'cert_public_name': 'name',
    'cert_public_price': 'price',
    'cert_purchase_url': 'URL',
    'number': 'Number',
    's_url': 'Url',
    'p_contact': 'Contact',
    'p_loc': 'Location',
    'p_owner': 'Owner',
    'sale': 'For sale',
    'p_descr': 'Description',
    's_cur': 'Currency',
    's_price': 'Price'
  },

  keysData: {
    available: { name: 'Available', order: 6 },
    title: { name: 'Title', order: 0 },
    created: { name: 'Created', order: 7 },
    entered: { name:'Entered', order: 8 },
    height: { name: 'Height', order: 5 },
    width: { name: 'Width', order: 4 } ,
    update: { name: 'Update', order: 9 } ,
    total: { name: 'Total', order: 10 },
    prints: { name: 'Prints', order: 9999 },
    size: { name: 'Size', order: 1 },
    year: { name: 'Year', order: 3},
    description: { name: 'Desciption', order: 6 }
  },

  menuList: [
    { name: 'Home', id: 'home' },
    { name: 'Huibert Van Dorp', id: 'huibert-van-dorp' },
    { name: 'About the Maps', id: 'about' },
    { name: 'Certification', id: 'certification' },
    { name: 'Contact', id: 'contact' },
  ],

};


// WEBPACK FOOTER //
// ./src/utils/config.js